import { render, staticRenderFns } from "./SamSidebarManager.vue?vue&type=template&id=11c5345a&shadow"
import script from "./SamSidebarManager.vue?vue&type=script&lang=js&shadow"
export * from "./SamSidebarManager.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports